import ReviewerSearchService from './reviewer-search-service';
import URLS from '@d-shared/urls/urls';

export default new ReviewerSearchService(URLS.api.leaderboard);
